import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
/**
 * テキスト内のemタグにハイライト用のクラスを付与するコンポーネント
 * （主にES検索結果レスポンスのhighlight文字列を装飾するために利用する想定です）
 * @param props
 * @returns
 */
export const HighlightText = (props) => {
    const { children } = props;
    const content = useMemo(() => {
        const transform = (node, index) => {
            if (!(node.type === 'tag' && node.name === 'em')) {
                // emタグでない場合、何もしない
                return undefined;
            }
            const convertedNode = node;
            // ハイライトのスタイルを付与
            convertedNode.attribs.class = clsx(convertedNode.attribs.class || '', 'not-italic', 'bg-turquoise-blue-50');
            return convertNodeToElement(convertedNode, index, transform);
        };
        return ReactHtmlParser(children, { transform });
    }, [children]);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return _jsx(_Fragment, { children: content });
};
